﻿import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, CardBody, Card, Container } from "reactstrap";
import { useLoginState } from "./useLoginState";
import LoginForm from "./LoginForms/LoginForm";

import porcherMark from "../../assets/images/porcher-logo.png";
import porcherWordmark from "../../assets/images/porcher-wordmark.png";

const Login = () => {
  document.title = "Login | Porcher";

  const ls = useLoginState();

  return (
    <div className="min-vh-100 d-flex align-items-center py-5" style={{ backgroundColor: "#f8f9fa" }}>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={6} xl={5}>

            <div className="text-center mb-4">
              <Link to="/" className="d-inline-flex align-items-center gap-2">
                <img src={porcherMark} alt="" height="36" />
                <img src={porcherWordmark} alt="Porcher" height="20" />
              </Link>
              <h5 className="mt-3 mb-0 fw-semibold">Welcome back</h5>
              <p className="text-muted small">Sign in to your account to continue</p>
            </div>

            <Card className="border-0 shadow-sm">
              <CardBody className="p-4">
                <LoginForm
                  loading={ls.loading}
                  setLoading={ls.setLoading}
                  error={ls.error}
                  setError={ls.setError}
                  returnUrl={ls.returnUrl}
                  mode={ls.mode}
                  navigate={ls.navigate}
                  loginWithGoogle={ls.loginWithGoogle}
                  checkAuth={ls.checkAuth}
                />
              </CardBody>
            </Card>

            <p className="text-center text-muted small mt-4">
              © {new Date().getFullYear()} Porcher
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;